import React, { useState, useEffect } from "react";
import ReactDOM from "react-dom";

import type { BottomSheetProps } from "../../BottomSheet";

interface PortalProps extends Pick<BottomSheetProps, "children" | "open"> {
  id: string;
}

const createContainer = (id: string): HTMLDivElement => {
  const container = document.createElement("div");
  container.setAttribute("id", id);
  document.body.appendChild(container);

  return container;
};

export const Portal = ({ id, open, children }: PortalProps) => {
  const [portalContainer, setPortalContainer] = useState<HTMLElement>();

  function actionHandler<T extends React.MouseEvent | React.KeyboardEvent>() {
    return (e: T) => {
      if ("key" in e && e.key !== "Enter" && e.key !== " ") {
        return;
      }
      e.stopPropagation();
    };
  }

  useEffect(() => {
    if (!open) return;

    setPortalContainer(document.getElementById(id) || createContainer(id));

    return () => {
      if (portalContainer) {
        document.body.removeChild(portalContainer);
      }
    };
  }, []);

  return open && portalContainer ? (
    <div
      onClick={actionHandler<React.MouseEvent>()}
      onKeyDown={actionHandler<React.KeyboardEvent>()}
    >
      {ReactDOM.createPortal(children, portalContainer)}
    </div>
  ) : null;
};
